import styled from 'styled-components';
import media from './MediaQueries';

const StyledDetails = styled.div`
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  h2.title {
    font-size: 20px;
    font-weight: 300;
    text-transform: capitalize;
  }

  span.location {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 700;
    color: #0091ff;
  }

  .productDesc {
    margin-top: 40px;
    display: flex;
    ${media.phone`
      flex-direction: column;
    `}
    img {
      width: 30%;
      height: 200px;
      object-fit: contain;
      ${media.phone`
        width: 100%;
      `}
    }
    .desc {
      display: flex;
      flex-direction: column;
      padding-left: 5%;
      h3.benefits {
        font-size: 16px;
        font-weight: 400;
      }
      p {
        margin-top: 20px;
        font-size: 14px;
      }
      span.quantity {
        margin-top: 20px;
      }
    }
  }

  .ratingSection {
    margin-top: 20px;
  }
  .reviewCountValue {
    font-size: 10px;
    color: gray;
  }

  .actions {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 40px;
    width: 100%;
    left: -5%;
    button {
      cursor: pointer;
      background: #bbb;
      border: 2px solid #bbb;
      padding: 8px;
      border-radius: 4px;
      color: white;
      font-style: italic;
      font-size: 14px;
      font-weight: 700;
      width: 30%;
    }
    button:disabled {
      background: #eee;
      border: 2px solid #eee;
    }
  }
`;

export default StyledDetails;



// WEBPACK FOOTER //
// ./src/components/instore/ProductDetails.style.js